class FaqSearch extends HTMLElement {
  connectedCallback() {
    this.input = this.querySelector('[data-faq-search-input]');
    this.pillsContainer = this.querySelector('[data-faq-pills]');
    this.items = this.querySelectorAll('[data-faq-item]');
    this.emptyState = this.querySelector('[data-faq-empty]');
    this.activeCategory = 'all';

    this.buildPills();

    this.input?.addEventListener('input', () => this.filter());
  }

  buildPills() {
    if (!this.pillsContainer) return;

    const seen = new Set();
    this.items.forEach((item) => {
      const value = item.dataset.faqItem;
      const label = item.dataset.faqItemLabel;
      if (!value || !label || seen.has(value)) return;
      seen.add(value);

      const pill = document.createElement('button');
      pill.type = 'button';
      pill.className = 'faq-search__pill';
      pill.dataset.faqCategory = value;
      pill.textContent = label;
      this.pillsContainer.appendChild(pill);
    });

    if (seen.size > 1) {
      this.pillsContainer.hidden = false;
    }

    this.pills = this.pillsContainer.querySelectorAll('[data-faq-category]');
    this.pills.forEach((pill) => {
      pill.addEventListener('click', () => {
        this.activeCategory = pill.dataset.faqCategory;
        this.pills.forEach((p) => p.classList.toggle('is-active', p === pill));
        this.filter();
      });
    });
  }

  filter() {
    const query = (this.input?.value || '').trim().toLowerCase();
    let visibleCount = 0;

    this.items.forEach((item) => {
      const matchesCategory = this.activeCategory === 'all' || item.dataset.faqItem === this.activeCategory;
      const text = item.textContent.toLowerCase();
      const matchesQuery = query === '' || text.includes(query);
      const visible = matchesCategory && matchesQuery;
      item.hidden = !visible;
      if (visible) visibleCount += 1;
    });

    if (this.emptyState) {
      this.emptyState.hidden = visibleCount > 0;
    }
  }
}

customElements.define('faq-search', FaqSearch);
